import { useMemo } from 'react'
import { shouldDisplayLogoV2 } from '../..'

const cdnPath = 'https://5cyl3vj1254k81w.highplayfky.com'

/**
 * `GodziSlotLoading` 的 Feature Toggle V2 版本——套用 `displayLogo`／`forceDisableLogo`
 * 優先權規則（`shouldDisplayLogoV2`），預設不顯示 logo。只有支援 Feature Toggle V2 且需要
 * `displayLogo` 的遊戲該用這個版本，詳見 docs/feature-toggle-v2-status/issues/display-logo-spec.md。
 */
export const GodziSlotLoadingFeatureToggleV2 = () => {
  const isMobile = window.innerWidth < 1024

  const logoSrc = useMemo(() => {
    const basePath = cdnPath
    const defaultLogoUrl = `${cdnPath}/common/logo/FG.png`

    const storageKey = 'logoUrl'
    const urlParams = new URLSearchParams(window.location.search)
    const logoUrl = urlParams.get('logoUrl')
    if (logoUrl) {
      if (logoUrl !== 'default') {
        const customizedUrl = basePath + logoUrl
        sessionStorage.setItem(storageKey, customizedUrl)
        return customizedUrl
      }
      sessionStorage.removeItem(storageKey)
    }
    return sessionStorage.getItem(storageKey) || defaultLogoUrl
  }, [])

  return (
    shouldDisplayLogoV2()
      ? (
          <div
            id="background"
            style={{
              position: 'fixed',
              display: 'flex',
              width: '100%',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#000000',
            }}
          >
            <img
              style={{
                width: isMobile ? '700px' : '1400px',
                objectFit: 'cover',
                maxWidth: 'none',
              }}
              alt="logoGif"
              src={`${cdnPath}/godziDrop/inGameLogo/godziLoading.gif`}
            />
            <img
              alt="powerByImg"
              src={logoSrc}
              style={{
                width: isMobile ? '200px' : '400px',
                transform: isMobile ? 'translateY(-120px)' : 'translateY(-240px)',
                objectFit: 'cover',
              }}
            />
          </div>
        )
      : <div id="loading-substitute"></div>
  )
}
